import {
  Component,
  NgZone,
  OnInit,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import { GridComponent, GridDataResult } from '@progress/kendo-angular-grid';
import { NotificationService } from '@progress/kendo-angular-notification';
import { State } from '@progress/kendo-data-query';
import { PageRequest } from 'src/app/models/entity-base';
import { RoleIds } from 'src/app/models/roles';
import { KendoGridHelper } from 'src/app/services/kendo-grid-helper';
import { LoadingService } from 'src/app/services/loading-service';
import {
  isExpired,
  RegistrationService,
} from 'src/app/services/registration-service';

@Component({
  selector: 'app-search-registration',
  templateUrl: './search-registration.component.html',
  styleUrls: ['./search-registration.component.scss'],
})
export class SearchRegistrationComponent implements OnInit {
  @ViewChild(GridComponent) grid!: GridComponent;
  @ViewChild('notificationAnchor', { read: ViewContainerRef, static: false })
  public notificationAnchor!: ViewContainerRef;
  kendoHelper!: KendoGridHelper;
  loadingData: boolean = true;
  searchQuery!: string;
  timeout: any;
  gridData!: GridDataResult;
  isExpired = isExpired;
  deleteConfirmationOpen = false;
  resendConfirmationOpen = false;
  currentDate = new Date();

  public gridState: any = {
    sort: [
      {
        field: 'create_time',
        dir: 'desc',
      },
    ],
    skip: 0,
    take: 10,
  };
  idToDelete: string = '';
  idToResend: string = '';
  constructor(
    public registrationService: RegistrationService,
    private loadingService: LoadingService,
    private notificationService: NotificationService
  ) {
    this.kendoHelper = new KendoGridHelper();
    this.loadingService.show();
  }
  ngOnInit(): void {}

  async ngAfterViewInit(): Promise<void> {
    await this.getData();
    this.loadingService.hide();
  }

  public async emitSearch(searchData: any) {
    this.searchQuery = searchData?.name;
    this.gridState.skip = 0;
    await this.getData();
  }

  async getData() {
    let sort = this.kendoHelper.getSortString(this.gridState?.sort);
    let request = new PageRequest();
    request.order_by = sort == '' ? 'createtime DESC' : sort;
    request.page_number = this.gridState.skip / this.gridState.take + 1;
    request.page_size = this.gridState.take;
    request.where = `(${
      this.kendoHelper.getFullFilterString(this.gridState?.filter) ?? '1=1'
    }) AND RoleId=${RoleIds.Member}`;

    try {
      this.loadingData = true;
      let response = await this.registrationService.adminSearch(request);
      this.gridData = {
        data: response.data,
        total: response.total_count,
      };
    } catch (err) {
      console.error(err);
    } finally {
      this.loadingData = false;
    }
  }

  public async onStateChange(state: State): Promise<void> {
    this.gridState = state;
    await this.getData();
  }

  async resend() {
    this.loadingData = true;
    await this.registrationService.resend(this.idToResend);
    this.notificationService.show({
      appendTo: this.notificationAnchor,
      content: 'Registration re-sent successfully!',
      animation: { type: 'fade', duration: 400 },
      position: { horizontal: 'right', vertical: 'bottom' },
      type: { style: 'success', icon: true },
    });
    await this.getData();
    this.loadingData = false;
    this.resendConfirmationOpen = false;
  }

  async confirmResend(id: string) {
    this.resendConfirmationOpen = true;
    this.idToResend = id;
  }

  public async delete() {
    this.loadingData = true;
    await this.registrationService.delete(this.idToDelete);
    await this.getData();
    this.idToDelete = '';
    this.loadingData = false;
    this.deleteConfirmationOpen = false;
  }

  async confirmDelete(id: string) {
    this.deleteConfirmationOpen = true;
    this.idToDelete = id;
  }

  cancel() {
    this.idToDelete = '';
    this.idToResend = '';
    this.deleteConfirmationOpen = false;
    this.resendConfirmationOpen = false;
  }

  daysBetween(endDate: Date) {
    const ONE_DAY = 1000 * 60 * 60 * 24;
    return Math.round(
      Math.abs((new Date().getTime() - new Date(endDate).getTime()) / ONE_DAY)
    );
  }
}
